import { Component, inject } from '@angular/core';
import { DxTabsComponent } from 'devextreme-angular';
import { AccessType, AuthService, PermissionType } from '@services';
import { GlCodesComponent } from './gl-codes/gl-codes.component';
import { GlCodeClientsComponent } from './gl-code-clients/gl-code-clients.component';


type TabKey = 'glCodes' | 'glClients';

@Component({
    selector: 'app-gl-code',
    imports: [
        DxTabsComponent,
        GlCodesComponent,
        GlCodeClientsComponent,
    ],
    templateUrl: './gl-code.component.html',
})
export class GlCodeComponent {
    private auth = inject(AuthService);

    selectedTab: TabKey = this.showGlCodes ? 'glCodes' : 'glClients';

    get showGlCodes(): boolean {
        return this.auth.checkPermission(PermissionType.GlCodes, AccessType.ViewOnly);
    }

    get showGlCodesClients(): boolean {
        return this.auth.checkPermission(PermissionType.GlCodesClients, AccessType.ViewOnly);
    }

    allTabs = [
        { key: 'glCodes', text: 'GL Codes', permission: PermissionType.GlCodes },
        { key: 'glClients', text: 'Sites', permission: PermissionType.GlCodesClients },
    ];

    tabs = this.allTabs.filter((t) => this.auth.checkPermission(t.permission, AccessType.ViewOnly));

    gridOffset = this.tabs.length > 1 ? 156 : 100;
}
